// import React, { useEffect, useState } from "react";
// import Forbidden403 from "../../components/common/Forbidden403";
// import { useAuth } from "../../App";
// import { hasPermission } from "../../utils/permissions";
// import {
//   Box,
//   Typography,
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Button,
//   TextField,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   CircularProgress,
//   Snackbar,
//   Alert
// } from "@mui/material";

// import { API_URL } from "../../config";

// export default function EmailSettings() {
//   const { auth, fetchWithAuth } = useAuth();
//   // Permission check: superuser or has 'email:list' permission
//   const hasReadPermission = hasPermission(auth?.user, "email.read");
//   if (!hasReadPermission) {
//     return <Forbidden403 />;
//   }
//   // State for settings
//   const [settings, setSettings] = useState(null);
//   const [settingsLoading, setSettingsLoading] = useState(true);
//   const [settingsError, setSettingsError] = useState("");
//   const [settingsSuccess, setSettingsSuccess] = useState(false);
//   const [editSettings, setEditSettings] = useState(false);
//   const [settingsForm, setSettingsForm] = useState({ sendgrid_api_key: "", default_from_email: "" });

//   // State for templates
//   const [templates, setTemplates] = useState([]);
//   const [templatesLoading, setTemplatesLoading] = useState(true);
//   const [templatesError, setTemplatesError] = useState("");
//   const [templateDialogOpen, setTemplateDialogOpen] = useState(false);
//   const [templateForm, setTemplateForm] = useState({ name: "", subject: "", body: "", body_html: "", description: "" });
//   const [templateEditId, setTemplateEditId] = useState(null);
//   const [templateFormError, setTemplateFormError] = useState("");
//   const [templateSuccess, setTemplateSuccess] = useState(false);

//   // Fetch settings
//   useEffect(() => {
//     setSettingsLoading(true);
//     fetchWithAuth(`${API_URL}/email/settings/`)
//       .then(res => {
//         if (res.status === 404) throw new Error("not found");
//         if (!res.ok) throw new Error("Failed to fetch settings");
//         return res.json();
//       })
//       .then(data => {
//         setSettings(data);
//         setSettingsForm({
//           sendgrid_api_key: data.sendgrid_api_key,
//           default_from_email: data.default_from_email
//         });
//         setSettingsError("");
//       })
//       .catch(e => setSettingsError(e.message))
//       .finally(() => setSettingsLoading(false));
//   }, [fetchWithAuth]);

//   // Fetch templates
//   useEffect(() => {
//     setTemplatesLoading(true);
//     fetchWithAuth(`${API_URL}/email/templates/`)
//       .then(res => {
//         if (!res.ok) throw new Error("Failed to fetch templates");
//         return res.json();
//       })
//       .then(data => {
//         setTemplates(data);
//         setTemplatesError("");
//       })
//       .catch(e => setTemplatesError(e.message))
//       .finally(() => setTemplatesLoading(false));
//   }, [templateSuccess, fetchWithAuth]);

//   // Handlers for settings
//   const handleEditSettings = () => setEditSettings(true);
//   const handleSettingsChange = e => setSettingsForm({ ...settingsForm, [e.target.name]: e.target.value });
//   const handleSettingsSave = () => {
//     fetchWithAuth(`${API_URL}/email/settings/`, {
//       method: "PUT",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify(settingsForm)
//     })
//       .then(res => {
//         if (!res.ok) throw new Error("Failed to update settings");
//         return res.json();
//       })
//       .then(data => {
//         setSettings(data);
//         setEditSettings(false);
//         setSettingsSuccess(true);
//       })
//       .catch(e => setSettingsError(e.message));
//   };
//   const handleCreateSettings = () => {
//     fetchWithAuth(`${API_URL}/email/settings/`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify(settingsForm)
//     })
//       .then(res => {
//         if (!res.ok) throw new Error("Failed to create settings");
//         return res.json();
//       })
//       .then(data => {
//         setSettings(data);
//         setSettingsSuccess(true);
//         setSettingsError("");
//       })
//       .catch(e => setSettingsError(e.message));
//   };
//   const handleDeleteSettings = () => {
//     if (!window.confirm("Delete email settings?")) return;
//     fetchWithAuth(`${API_URL}/email/settings/`, { method: "DELETE" })
//       .then(res => {
//         if (!res.ok) throw new Error("Failed to delete settings");
//         setSettings(null);
//         setSettingsForm({ sendgrid_api_key: "", default_from_email: "" });
//       })
//       .catch(e => setSettingsError(e.message));
//   };

//   // Handlers for templates
//   const handleOpenTemplateDialog = (tpl = null) => {
//     if (tpl) {
//       setTemplateForm(tpl);
//       setTemplateEditId(tpl.id);
//     } else {
//       setTemplateForm({ name: "", subject: "", body: "", body_html: "", description: "" });
//       setTemplateEditId(null);
//     }
//     setTemplateFormError("");
//     setTemplateDialogOpen(true);
//   };
//   const handleCloseTemplateDialog = () => setTemplateDialogOpen(false);
//   const handleTemplateFormChange = e => setTemplateForm({ ...templateForm, [e.target.name]: e.target.value });
//   const handleTemplateSave = () => {
//     if (!templateForm.name || !templateForm.subject || !templateForm.body) {
//       setTemplateFormError("Name, subject, and body are required");
//       return;
//     }
//     setTemplateFormError("");
//     const method = templateEditId ? "PUT" : "POST";
//     const url = `${API_URL}/email/templates/${templateEditId || ""}`;
//     fetchWithAuth(url, {
//       method,
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify(templateForm)
//     })
//       .then(res => {
//         if (!res.ok) throw new Error("Failed to save template");
//         return res.json();
//       })
//       .then(() => {
//         setTemplateDialogOpen(false);
//         setTemplateSuccess(s => !s);
//       })
//       .catch(e => setTemplateFormError(e.message));
//   };
//   const handleTemplateDelete = (id) => {
//     if (!window.confirm("Delete this template?")) return;
//     fetchWithAuth(`${API_URL}/email/templates/${id}`, { method: "DELETE" })
//       .then(res => {
//         if (!res.ok) throw new Error("Failed to delete template");
//         setTemplateSuccess(s => !s);
//       })
//       .catch(e => setTemplatesError(e.message));
//   };

//   return (
//     <Box sx={{ p: 3, maxWidth: 900, mx: "auto" }}>
//       <Typography variant="h4" gutterBottom>Email Settings</Typography>
//       <Paper sx={{ p: 2, mb: 4 }}>
//         {settingsLoading ? (
//           <CircularProgress />
//         ) : settingsError && settingsError.includes('not found') ? (
//           <>
//             <Alert severity="info">No email settings found. Please create them below.</Alert>
//             <Box sx={{ mt: 2 }}>
//               <TextField
//                 label="SendGrid API Key"
//                 name="sendgrid_api_key"
//                 value={settingsForm.sendgrid_api_key}
//                 onChange={handleSettingsChange}
//                 fullWidth
//                 margin="normal"
//                 type="password"
//               />
//               <TextField
//                 label="Default From Email"
//                 name="default_from_email"
//                 value={settingsForm.default_from_email}
//                 onChange={handleSettingsChange}
//                 fullWidth
//                 margin="normal"
//               />
//               <Button sx={{ mt: 2 }} variant="contained" onClick={handleCreateSettings}>Create Settings</Button>
//             </Box>
//           </>
//         ) : settingsError ? (
//           <Alert severity="error">{settingsError}</Alert>
//         ) : (
//           <>
//             <TextField
//               label="SendGrid API Key"
//               name="sendgrid_api_key"
//               value={settingsForm.sendgrid_api_key}
//               onChange={handleSettingsChange}
//               fullWidth
//               margin="normal"
//               type="password"
//               disabled={!editSettings}
//             />
//             <TextField
//               label="Default From Email"
//               name="default_from_email"
//               value={settingsForm.default_from_email}
//               onChange={handleSettingsChange}
//               fullWidth
//               margin="normal"
//               disabled={!editSettings}
//             />
//             {editSettings ? (
//               <Box sx={{ mt: 2 }}>
//                 <Button variant="contained" onClick={handleSettingsSave} sx={{ mr: 2 }}>Save</Button>
//                 <Button onClick={() => setEditSettings(false)}>Cancel</Button>
//               </Box>
//             ) : (
//               <>
//                 <Button sx={{ mt: 2 }} variant="outlined" onClick={handleEditSettings}>Edit Settings</Button>
//                 <Button sx={{ mt: 2, ml: 2 }} color="error" variant="outlined" onClick={handleDeleteSettings} disabled>Delete Settings</Button>
//               </>
//             )}
//           </>
//         )}
//       </Paper>

//       <Typography variant="h5" gutterBottom>Email Templates</Typography>
//       <Paper sx={{ p: 2 }}>
//         <Box sx={{ mb: 2, display: "flex", justifyContent: "flex-end" }}>
//           <Button variant="contained" onClick={() => handleOpenTemplateDialog()}>Add Template</Button>
//         </Box>
//         {templatesLoading ? (
//           <CircularProgress />
//         ) : templatesError ? (
//           <Alert severity="error">{templatesError}</Alert>
//         ) : (
//           <TableContainer>
//             <Table size="small">
//               <TableHead>
//                 <TableRow>
//                   <TableCell>Name</TableCell>
//                   <TableCell>Subject</TableCell>
//                   <TableCell>Description</TableCell>
//                   <TableCell>Actions</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {templates.map(tpl => (
//                   <TableRow key={tpl.id}>
//                     <TableCell>{tpl.name}</TableCell>
//                     <TableCell>{tpl.subject}</TableCell>
//                     <TableCell>{tpl.description}</TableCell>
//                     <TableCell>
//                       <Button size="small" onClick={() => handleOpenTemplateDialog(tpl)}>Edit</Button>
//                       <Button size="small" color="error" onClick={() => handleTemplateDelete(tpl.id)} disabled>Delete</Button>
//                     </TableCell>
//                   </TableRow>
//                 ))}
//               </TableBody>
//             </Table>
//           </TableContainer>
//         )}
//       </Paper>

//       <Dialog open={templateDialogOpen} onClose={handleCloseTemplateDialog} maxWidth="sm" fullWidth>
//         <DialogTitle>{templateEditId ? "Edit Template" : "Add Template"}</DialogTitle>
//         <DialogContent>
//           <TextField
//             label="Name"
//             name="name"
//             value={templateForm.name}
//             onChange={handleTemplateFormChange}
//             fullWidth
//             margin="normal"
//             disabled={!!templateEditId}
//           />
//           <TextField
//             label="Subject"
//             name="subject"
//             value={templateForm.subject}
//             onChange={handleTemplateFormChange}
//             fullWidth
//             margin="normal"
//           />
//           <TextField
//             label="Description"
//             name="description"
//             value={templateForm.description}
//             onChange={handleTemplateFormChange}
//             fullWidth
//             margin="normal"
//           />
//           <TextField
//             label="Body (Plain Text)"
//             name="body"
//             value={templateForm.body}
//             onChange={handleTemplateFormChange}
//             fullWidth
//             margin="normal"
//             multiline
//             minRows={3}
//           />
//           <TextField
//             label="Body (HTML)"
//             name="body_html"
//             value={templateForm.body_html}
//             onChange={handleTemplateFormChange}
//             fullWidth
//             margin="normal"
//             multiline
//             minRows={3}
//           />
//           {templateFormError && <Alert severity="error">{templateFormError}</Alert>}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleCloseTemplateDialog}>Cancel</Button>
//           <Button variant="contained" onClick={handleTemplateSave}>{templateEditId ? "Save" : "Create"}</Button>
//         </DialogActions>
//       </Dialog>

//       <Snackbar open={settingsSuccess} autoHideDuration={3000} onClose={() => setSettingsSuccess(false)}>
//         <Alert onClose={() => setSettingsSuccess(false)} severity="success" sx={{ width: '100%' }}>
//           Settings updated successfully!
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// }


import React, { useEffect, useState } from "react";
import Forbidden403 from "../../components/common/Forbidden403";
import { useAuth } from "../../App";
import { hasPermission } from "../../utils/permissions";
import AdminSidebar from "../../AdminSidebar";
import {
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
  Snackbar,
  Alert,
  Container,
  Toolbar,
} from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";

import { API_URL } from "../../config";

function SectionEyebrow({ children, color }) {
  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 1.25,
        color,
        fontFamily: '"DM Mono", ui-monospace, SFMono-Regular, Menlo, monospace',
        fontSize: "10.5px",
        letterSpacing: "0.18em",
        textTransform: "uppercase",
        fontWeight: 500,
      }}
    >
      <Box
        sx={{
          width: 24,
          height: 2,
          borderRadius: 2,
          bgcolor: "currentColor",
          flexShrink: 0,
        }}
      />
      {children}
    </Box>
  );
}

export default function EmailSettings() {
  const theme = useTheme();
  const dark = theme.palette.mode === "dark";

  const accent = dark ? "#fb923c" : "#f97316";
  const pageBg = dark ? "#07080f" : "#ffffff";
  const panelBg = dark ? "#0d1220" : "#ffffff";
  const text = dark ? "#e8f0fe" : "#0f0f1a";
  const mid = dark ? "#94a3b8" : "#4b4b6a";
  const muted = dark ? "#4b6080" : "#9898b8";
  const border = dark ? "rgba(99, 179, 237, 0.10)" : "#e8e8f0";

  const { auth, fetchWithAuth } = useAuth();
  const hasReadPermission = hasPermission(auth?.user, "email.read");

  if (!hasReadPermission) {
    return (
      <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: pageBg }}>
        <AdminSidebar selected="Email Settings" />
        <Box
          sx={{
            flex: 1,
            p: 3,
            mt: 7,
            mb: 3,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Forbidden403 />
        </Box>
      </Box>
    );
  }

  const [settings, setSettings] = useState(null);
  const [settingsLoading, setSettingsLoading] = useState(true);
  const [settingsError, setSettingsError] = useState("");
  const [settingsSuccess, setSettingsSuccess] = useState(false);
  const [editSettings, setEditSettings] = useState(false);
  const [settingsForm, setSettingsForm] = useState({
    sendgrid_api_key: "",
    default_from_email: "",
  });

  const [templates, setTemplates] = useState([]);
  const [templatesLoading, setTemplatesLoading] = useState(true);
  const [templatesError, setTemplatesError] = useState("");
  const [templateDialogOpen, setTemplateDialogOpen] = useState(false);
  const [templateForm, setTemplateForm] = useState({
    name: "",
    subject: "",
    body: "",
    body_html: "",
    description: "",
  });
  const [templateEditId, setTemplateEditId] = useState(null);
  const [templateFormError, setTemplateFormError] = useState("");
  const [templateSuccess, setTemplateSuccess] = useState(false);

  useEffect(() => {
    setSettingsLoading(true);
    fetchWithAuth(`${API_URL}/email/settings/`)
      .then((res) => {
        if (res.status === 404) throw new Error("not found");
        if (!res.ok) throw new Error("Failed to fetch settings");
        return res.json();
      })
      .then((data) => {
        setSettings(data);
        setSettingsForm({
          sendgrid_api_key: data.sendgrid_api_key,
          default_from_email: data.default_from_email,
        });
        setSettingsError("");
      })
      .catch((e) => setSettingsError(e.message))
      .finally(() => setSettingsLoading(false));
  }, [fetchWithAuth]);

  useEffect(() => {
    setTemplatesLoading(true);
    fetchWithAuth(`${API_URL}/email/templates/`)
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch templates");
        return res.json();
      })
      .then((data) => {
        setTemplates(data);
        setTemplatesError("");
      })
      .catch((e) => setTemplatesError(e.message))
      .finally(() => setTemplatesLoading(false));
  }, [templateSuccess, fetchWithAuth]);

  const handleEditSettings = () => setEditSettings(true);

  const handleSettingsChange = (e) =>
    setSettingsForm({ ...settingsForm, [e.target.name]: e.target.value });

  const handleSettingsSave = () => {
    fetchWithAuth(`${API_URL}/email/settings/`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(settingsForm),
    })
      .then((res) => {
        if (!res.ok) throw new Error("Failed to update settings");
        return res.json();
      })
      .then((data) => {
        setSettings(data);
        setEditSettings(false);
        setSettingsSuccess(true);
      })
      .catch((e) => setSettingsError(e.message));
  };

  const handleCreateSettings = () => {
    fetchWithAuth(`${API_URL}/email/settings/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(settingsForm),
    })
      .then((res) => {
        if (!res.ok) throw new Error("Failed to create settings");
        return res.json();
      })
      .then((data) => {
        setSettings(data);
        setSettingsSuccess(true);
        setSettingsError("");
      })
      .catch((e) => setSettingsError(e.message));
  };

  const handleDeleteSettings = () => {
    if (!window.confirm("Delete email settings?")) return;
    fetchWithAuth(`${API_URL}/email/settings/`, { method: "DELETE" })
      .then((res) => {
        if (!res.ok) throw new Error("Failed to delete settings");
        setSettings(null);
        setSettingsForm({ sendgrid_api_key: "", default_from_email: "" });
      })
      .catch((e) => setSettingsError(e.message));
  };

  const handleOpenTemplateDialog = (tpl = null) => {
    if (tpl) {
      setTemplateForm(tpl);
      setTemplateEditId(tpl.id);
    } else {
      setTemplateForm({
        name: "",
        subject: "",
        body: "",
        body_html: "",
        description: "",
      });
      setTemplateEditId(null);
    }
    setTemplateFormError("");
    setTemplateDialogOpen(true);
  };

  const handleCloseTemplateDialog = () => setTemplateDialogOpen(false);

  const handleTemplateFormChange = (e) =>
    setTemplateForm({ ...templateForm, [e.target.name]: e.target.value });

  const handleTemplateSave = () => {
    if (!templateForm.name || !templateForm.subject || !templateForm.body) {
      setTemplateFormError("Name, subject, and body are required");
      return;
    }
    setTemplateFormError("");
    const method = templateEditId ? "PUT" : "POST";
    const url = `${API_URL}/email/templates/${templateEditId || ""}`;
    fetchWithAuth(url, {
      method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(templateForm),
    })
      .then((res) => {
        if (!res.ok) throw new Error("Failed to save template");
        return res.json();
      })
      .then(() => {
        setTemplateDialogOpen(false);
        setTemplateSuccess((s) => !s);
      })
      .catch((e) => setTemplateFormError(e.message));
  };

  const handleTemplateDelete = (id) => {
    if (!window.confirm("Delete this template?")) return;
    fetchWithAuth(`${API_URL}/email/templates/${id}`, { method: "DELETE" })
      .then((res) => {
        if (!res.ok) throw new Error("Failed to delete template");
        setTemplateSuccess((s) => !s);
      })
      .catch((e) => setTemplatesError(e.message));
  };

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: pageBg }}>
      <AdminSidebar selected="Email Settings" />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          pl: { xs: 1.5, md: 3 },
          pr: { xs: 1.5, md: 3 },
          pt: 2,
          pb: 3,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Toolbar />

        <Container maxWidth="xl" disableGutters sx={{ mt: 1 }}>
          <Box
            sx={{
              mb: 3,
              overflow: "hidden",
              borderRadius: "28px",
              border: `1px solid ${border}`,
              background: dark
                ? `linear-gradient(135deg, ${alpha(accent, 0.14)} 0%, rgba(7,8,15,0.96) 45%, rgba(7,8,15,0.98) 100%)`
                : `linear-gradient(135deg, ${alpha(accent, 0.14)} 0%, rgba(255,255,255,0.98) 42%, rgba(248,248,251,0.98) 100%)`,
              boxShadow: dark
                ? "0 32px 80px rgba(0,0,0,0.30)"
                : "0 32px 80px rgba(15,15,26,0.08)",
            }}
          >
            <Box
              sx={{
                p: { xs: 3, sm: 4, md: 5 },
                display: "flex",
                alignItems: { xs: "flex-start", sm: "center" },
                justifyContent: "space-between",
                flexWrap: "wrap",
                gap: 1.5,
              }}
            >
              <Box>
                <SectionEyebrow color={accent}>AjiraHQ · Email Settings</SectionEyebrow>
                <Typography
                  sx={{
                    mt: 2,
                    color: text,
                    fontWeight: 800,
                    fontSize: "clamp(30px, 4vw, 44px)",
                    lineHeight: 1.06,
                    letterSpacing: "-0.03em",
                    mb: 0.75,
                  }}
                >
                  Manage email settings and templates.
                </Typography>
                <Typography
                  sx={{
                    color: mid,
                    fontSize: "15px",
                    lineHeight: 1.8,
                    maxWidth: 700,
                  }}
                >
                  Configure email delivery defaults and maintain reusable email templates
                  while keeping the existing email logic unchanged.
                </Typography>
              </Box>
            </Box>
          </Box>

          <Paper
            elevation={0}
            sx={{
              p: 2.5,
              mb: 3,
              borderRadius: "22px",
              background: panelBg,
              border: `1px solid ${border}`,
              boxShadow: dark
                ? "0 20px 50px rgba(0,0,0,0.20)"
                : "0 12px 30px rgba(15,23,42,0.06)",
            }}
          >
            <Typography
              sx={{
                fontWeight: 800,
                fontSize: "1.2rem",
                color: text,
                mb: 2,
                letterSpacing: "-0.02em",
              }}
            >
              Email Settings
            </Typography>

            {settingsLoading ? (
              <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
                <CircularProgress sx={{ color: accent }} />
              </Box>
            ) : settingsError && settingsError.includes("not found") ? (
              <>
                <Alert severity="info" sx={{ mb: 2, borderRadius: "18px" }}>
                  No email settings found. Please create them below.
                </Alert>

                <Box sx={{ display: "grid", gap: 2 }}>
                  <TextField
                    label="SendGrid API Key"
                    name="sendgrid_api_key"
                    value={settingsForm.sendgrid_api_key}
                    onChange={handleSettingsChange}
                    fullWidth
                    type="password"
                  />
                  <TextField
                    label="Default From Email"
                    name="default_from_email"
                    value={settingsForm.default_from_email}
                    onChange={handleSettingsChange}
                    fullWidth
                  />
                  <Box>
                    <Button variant="contained" onClick={handleCreateSettings}>
                      Create Settings
                    </Button>
                  </Box>
                </Box>
              </>
            ) : settingsError ? (
              <Alert severity="error" sx={{ borderRadius: "18px" }}>
                {settingsError}
              </Alert>
            ) : (
              <>
                <Box sx={{ display: "grid", gap: 2 }}>
                  <TextField
                    label="SendGrid API Key"
                    name="sendgrid_api_key"
                    value={settingsForm.sendgrid_api_key}
                    onChange={handleSettingsChange}
                    fullWidth
                    type="password"
                    disabled={!editSettings}
                  />
                  <TextField
                    label="Default From Email"
                    name="default_from_email"
                    value={settingsForm.default_from_email}
                    onChange={handleSettingsChange}
                    fullWidth
                    disabled={!editSettings}
                  />
                </Box>

                {editSettings ? (
                  <Box sx={{ mt: 2, display: "flex", gap: 1.5 }}>
                    <Button variant="contained" onClick={handleSettingsSave}>
                      Save
                    </Button>
                    <Button onClick={() => setEditSettings(false)}>Cancel</Button>
                  </Box>
                ) : (
                  <Box sx={{ mt: 2, display: "flex", gap: 1.5 }}>
                    <Button variant="outlined" onClick={handleEditSettings}>
                      Edit Settings
                    </Button>
                    <Button
                      color="error"
                      variant="outlined"
                      onClick={handleDeleteSettings}
                      disabled
                    >
                      Delete Settings
                    </Button>
                  </Box>
                )}
              </>
            )}
          </Paper>

          <Paper
            elevation={0}
            sx={{
              p: 2.5,
              borderRadius: "22px",
              background: panelBg,
              border: `1px solid ${border}`,
              boxShadow: dark
                ? "0 20px 50px rgba(0,0,0,0.20)"
                : "0 12px 30px rgba(15,23,42,0.06)",
            }}
          >
            <Box
              sx={{
                mb: 2,
                display: "flex",
                justifyContent: "space-between",
                alignItems: { xs: "flex-start", sm: "center" },
                flexWrap: "wrap",
                gap: 1.5,
              }}
            >
              <Typography
                sx={{
                  fontWeight: 800,
                  fontSize: "1.2rem",
                  color: text,
                  letterSpacing: "-0.02em",
                }}
              >
                Email Templates
              </Typography>

              <Button variant="contained" onClick={() => handleOpenTemplateDialog()}>
                Add Template
              </Button>
            </Box>

            {templatesLoading ? (
              <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
                <CircularProgress sx={{ color: accent }} />
              </Box>
            ) : templatesError ? (
              <Alert severity="error" sx={{ borderRadius: "18px" }}>
                {templatesError}
              </Alert>
            ) : (
              <TableContainer
                sx={{
                  borderRadius: "18px",
                  border: `1px solid ${border}`,
                  overflowX: "auto",
                }}
              >
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      {["Name", "Subject", "Description", "Actions"].map((header) => (
                        <TableCell
                          key={header}
                          sx={{
                            fontWeight: 700,
                            color: mid,
                            background: dark ? "#111827" : "#fafafa",
                            borderBottom: `1px solid ${border}`,
                            whiteSpace: "nowrap",
                          }}
                        >
                          {header}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {templates.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={4} align="center">
                          <Typography sx={{ py: 3, color: muted }}>
                            No templates found.
                          </Typography>
                        </TableCell>
                      </TableRow>
                    ) : (
                      templates.map((tpl) => (
                        <TableRow
                          key={tpl.id}
                          hover
                          sx={{
                            "& td": {
                              borderBottom: `1px solid ${border}`,
                              background: dark ? "rgba(13,18,32,0.96)" : "#ffffff",
                              color: mid,
                            },
                            "&:hover td": {
                              background: dark
                                ? "rgba(255,255,255,0.03)"
                                : "rgba(15,15,26,0.02)",
                            },
                          }}
                        >
                          <TableCell sx={{ color: text, fontWeight: 700 }}>
                            {tpl.name}
                          </TableCell>
                          <TableCell>{tpl.subject}</TableCell>
                          <TableCell>{tpl.description || "-"}</TableCell>
                          <TableCell sx={{ whiteSpace: "nowrap" }}>
                            <Button size="small" onClick={() => handleOpenTemplateDialog(tpl)}>
                              Edit
                            </Button>
                            <Button
                              size="small"
                              color="error"
                              onClick={() => handleTemplateDelete(tpl.id)}
                              disabled
                            >
                              Delete
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </Paper>

          <Dialog
            open={templateDialogOpen}
            onClose={handleCloseTemplateDialog}
            maxWidth="sm"
            fullWidth
          >
            <DialogTitle
              sx={{
                fontWeight: 800,
                color: text,
                letterSpacing: "-0.02em",
              }}
            >
              {templateEditId ? "Edit Template" : "Add Template"}
            </DialogTitle>

            <DialogContent dividers>
              <TextField
                label="Name"
                name="name"
                value={templateForm.name}
                onChange={handleTemplateFormChange}
                fullWidth
                margin="normal"
                disabled={!!templateEditId}
              />
              <TextField
                label="Subject"
                name="subject"
                value={templateForm.subject}
                onChange={handleTemplateFormChange}
                fullWidth
                margin="normal"
              />
              <TextField
                label="Description"
                name="description"
                value={templateForm.description}
                onChange={handleTemplateFormChange}
                fullWidth
                margin="normal"
              />
              <TextField
                label="Body (Plain Text)"
                name="body"
                value={templateForm.body}
                onChange={handleTemplateFormChange}
                fullWidth
                margin="normal"
                multiline
                minRows={3}
              />
              <TextField
                label="Body (HTML)"
                name="body_html"
                value={templateForm.body_html}
                onChange={handleTemplateFormChange}
                fullWidth
                margin="normal"
                multiline
                minRows={3}
              />
              {templateFormError && (
                <Alert severity="error" sx={{ mt: 2 }}>
                  {templateFormError}
                </Alert>
              )}
            </DialogContent>

            <DialogActions sx={{ px: 3, py: 2 }}>
              <Button onClick={handleCloseTemplateDialog}>Cancel</Button>
              <Button variant="contained" onClick={handleTemplateSave}>
                {templateEditId ? "Save" : "Create"}
              </Button>
            </DialogActions>
          </Dialog>

          <Snackbar
            open={settingsSuccess}
            autoHideDuration={3000}
            onClose={() => setSettingsSuccess(false)}
          >
            <Alert
              onClose={() => setSettingsSuccess(false)}
              severity="success"
              sx={{ width: "100%" }}
            >
              Settings updated successfully!
            </Alert>
          </Snackbar>
        </Container>
      </Box>
    </Box>
  );
}